enum SessionStorageKeys {
  UsersTablePage = 'UsersTablePage',
  DictionariesTablePage = 'DictionariesTablePage',
  ProjectsTablePage = 'ProjectsTablePage',
  CostSummaryTablePage = 'CostSummaryTablePage',
  DemandsTablePage = 'DemandsTablePage',
  RecruitmentsTablePage = 'RecruitmentsTablePage',
  RolesTablePage = 'RolesTablePage',
  ReportsProjectsTablePage = 'ReportsProjectsTablePage',
  ReportsUsersTablePage = 'ReportsUsersTablePage',
  PermissionsTablePage = 'PermissionsTablePage',
  ProjectCostsTablePage = 'ProjectCostsTablePage',
  EmploymentTablePage = 'EmploymentTablePage',
}

export default SessionStorageKeys
